import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';

export const INDUSTRIES = [
  {
    code:  'ev',
    label: '电动汽车',
    title: '电动汽车新能源客服',
    motto: '绿色出行 · 智慧服务 · 未来驱动',
  },
  {
    code:  'psychology',
    label: '心理咨询',
    title: '青少年心理咨询助手',
    motto: '温暖倾听 · 专业引导 · 健康成长',
  },
  {
    code:  'medical_beauty',
    label: '医美行业',
    title: '医美行业智能客服',
    motto: '专业美学 · 安全无忧 · 焕然新生',
  },
  {
    code:  'pet_hosting',
    label: '宠物托管',
    title: '宠物托管中心客服',
    motto: '用心呵护 · 专业照料 · 安心托付',
  },
];

const IndustryContext = createContext({ industry: 'ev', industryInfo: null, loading: true });

function getIndustryFromUrl() {
  if (typeof window === 'undefined') return 'ev';
  const params = new URLSearchParams(window.location.search);
  const code = params.get('industry') || 'ev';
  return INDUSTRIES.some(i => i.code === code) ? code : 'ev';
}

export function IndustryProvider({ children }) {
  const [industry, setIndustryState] = useState(getIndustryFromUrl);
  const [industryInfo, setIndustryInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const syncFromUrl = () => {
      const fromUrl = getIndustryFromUrl();
      setIndustryState(prev => (prev !== fromUrl ? fromUrl : prev));
    };
    syncFromUrl();
    window.addEventListener('popstate', syncFromUrl);
    return () => window.removeEventListener('popstate', syncFromUrl);
  }, []);

  useEffect(() => {
    const found = INDUSTRIES.find(i => i.code === (industry || 'ev')) || INDUSTRIES[0];
    setLoading(true);
    setIndustryInfo({ code: found.code, name: found.label, title: found.title, motto: found.motto });
    setLoading(false);
  }, [industry]);

  const value = useMemo(() => ({ industry, industryInfo, loading }), [industry, industryInfo, loading]);
  return <IndustryContext.Provider value={value}>{children}</IndustryContext.Provider>;
}

export function useIndustry() {
  return useContext(IndustryContext);
}
